import { useState } from "react";
import { toast } from "sonner";
import { ThumbsDown, ThumbsUp } from "lucide-react";
import { errMsg, useApi } from "@/lib/api";
import { Button } from "@/components/ui/button";

// «Ti è utile?»: stored as an event for a future ADM Intelligence (no analytics/AI now).
export function Feedback({ tid, area }) {
  const api = useApi();
  const [done, setDone] = useState(false);
  const send = async (useful) => {
    try { await api.post(`/t/${tid}/feedback`, { area, useful }); setDone(true); toast.success("Grazie per il riscontro"); } catch (e) { toast.error(errMsg(e)); }
  };
  if (done) return <p className="text-xs text-slate-500" data-testid={`feedback-done-${area}`}>Grazie: il tuo riscontro aiuta MUSORA a migliorare l'area clienti.</p>;
  return (
    <div className="flex items-center gap-2 text-xs text-slate-500" data-testid={`feedback-${area}`}>Questa pagina ti è utile?
      <Button size="icon" variant="ghost" className="h-10 w-10" aria-label="Sì" onClick={() => send(true)} data-testid={`feedback-yes-${area}`}><ThumbsUp size={14} /></Button>
      <Button size="icon" variant="ghost" className="h-10 w-10" aria-label="No" onClick={() => send(false)} data-testid={`feedback-no-${area}`}><ThumbsDown size={14} /></Button>
    </div>);
}
